export const chromaticHueDefault = 220.44
